<template>
  <button
    @click="handleClick"
    type="button"
    class="phone-code-button"
  >
    <div class="phone-code-button-content">
      <FlagIcon
        :iso-code="currentCountryIso"
        :width="36"
      />
      <svg
        class="phone-code-button-icon"
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 9L12 15L18 9"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </button>
</template>

<script setup lang="ts">
import FlagIcon from './FlagIcon.vue'

interface Props {
  currentCountryIso?: string
}

interface Emits {
  (e: 'click'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleClick = () => {
  emit('click')
}
</script>

<style scoped>
.phone-code-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-code-button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.phone-code-button-icon {
  color: var(--color-dark-blue, #252840);
  flex-shrink: 0;
}
</style>
